import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAdminAuthenticated } from '../services/adminSession';

/**
 * Lands on /admin and immediately redirects:
 *  - to /admin/dashboard when a valid admin session exists
 *  - to /admin/signin otherwise
 */
const AdminEntry = () => (
  <Navigate
    to={isAdminAuthenticated() ? '/admin/dashboard' : '/admin/signin'}
    replace
  />
);

export default AdminEntry;
